<template>
	<div class="card">
		<div class="card-header">
      <div>
          <div class="d-flex mb-3">
              <div>
                  <el-dropdown @command="changeOfferReport">
                    <span class="el-dropdown-link">
                      {{ offerReportTitle }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="offer">{{ $t('dashboard.monthly-offer') }}</el-dropdown-item>
                      <el-dropdown-item command="cashin">{{ $t('dashboard.monthly-cashin') }}</el-dropdown-item>
                      <el-dropdown-item command="on">{{ $t('dashboard.monthly-offer-no') }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
              </div>
              <span class="flex"></span>
              <div>
                  <el-dropdown @command="changeYear">
                    <span class="el-dropdown-link">
                      {{ $t('dashboard.select-year') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="y" v-for="y in years">{{ y }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
              </div>
          </div>
          
      </div>
			<!--<div class="pull-right">
				<el-dropdown @command="changeYear">
				  <span class="el-dropdown-link">
				    {{ $t('dashboard.select-year') }}<i class="el-icon-arrow-down el-icon--right"></i>
				  </span>
				  <el-dropdown-menu slot="dropdown">
				    <el-dropdown-item :command="y" v-for="y in years">{{ y }}</el-dropdown-item>
				  </el-dropdown-menu>
				</el-dropdown>
			</div>
			<h4 class="mb-0">
				<el-dropdown @command="changeOfferReport">
				  <span class="el-dropdown-link">
				    {{ offerReportTitle }}<i class="el-icon-arrow-down el-icon--right"></i>
				  </span>
				  <el-dropdown-menu slot="dropdown">
				    <el-dropdown-item command="offer">{{ $t('dashboard.monthly-offer') }}</el-dropdown-item>
				    <el-dropdown-item command="cashin">{{ $t('dashboard.monthly-cashin') }}</el-dropdown-item>
				    <el-dropdown-item command="on">{{ $t('dashboard.monthly-offer-no') }}</el-dropdown-item>
				  </el-dropdown-menu>
				</el-dropdown>
			</h4>-->
		</div>
		<div class="card-body">
			<div class="chart-wrapper">
				<Chart id="monthly-offer-report" :options="morOpt" />
			</div>
		</div>
	</div>
</template>
<style>
.chart-wrapper {
  height: 400px;
}
</style>
<script>
// @ is an alias to /src
import Chart from '@/components/dashboard/Chart.vue'
import moment from 'moment'

export default {
  name: 'MonthlyOfferReport',
  components: {
    Chart
  },
  data: function() {
    return {
      offerData: null,
	  morOpt: null,
	  currentYear: moment().year(),
	  currentOfferReport: 'offer'
	}
  },
  computed: {
    offerReportTitle: function() {
      if (this.currentOfferReport === 'offer') 
        return this.$t('dashboard.monthly-offer')
      else if (this.currentOfferReport === 'cashin')
        return this.$t('dashboard.monthly-cashin')
      else if (this.currentOfferReport === 'on')
        return this.$t('dashboard.monthly-offer-no')
    },
    years: function() {
      let thisYear = moment().year(),
          years = []
      for (let i = 2022; i <= thisYear; i ++)
        years.push(i)

      return years
    },
    months: function() {
      let months = [],
          lang = this.$i18n.locale
      if (lang === 'zh')
  	    moment.locale('zh-cn')
      else
  	    moment.locale(lang)

      for (let i = 1; i <= 12; i ++)
        months.push(moment('2022-' + ((i < 10) ? '0' + i : i) + '-01').format('MMM'))

      return months
    }
  },
  methods: {
    changeOfferReport: function(command) {
      this.currentOfferReport = command
      this.loadMOR(this.currentOfferReport)
    },
    async loadOfferData () {
      try {
        let query = '?userId=' + localStorage.getItem('token') + '&year=' + this.currentYear,
        	res = await this.$http.get(this.API_PREFIX + 'monthly_offer_report' + query)
        return res.data
      } catch (err) {
        console.log(err)
      }
    },
    changeYear: function(year) {
      this.currentYear = year
      this.offerData = this.loadOfferData()
      this.loadMOR(this.currentOfferReport)
    },
    loadMOR: function(reportType) {
      let that = this
      //clean history
      this.morOpt = {
	    legend: {
          data: [],
          align: 'left',
          left: 10
        },
		tooltip: {
		  trigger: 'axis',
		  formatter: (params) => {
		    let tt = '',
		        total = 0.0
		    if (params.length > 0)
		      tt += params[0].name + '<br />'
		    for (var i = 0; i < params.length; i ++) {
              tt += params[i].seriesName + ': ' + params[i].value + '<br />'
              total += parseFloat(params[i].value)
		    }
		    tt += '<hr>' + this.$t('dashboard.total') + ': ' + total.toFixed(2)
		    return tt
		  }
		},
		calculable: true,
		xAxis: {
      type: 'category',
		  data: []
		},
		yAxis: {},
		series: []
	  }

	  this.offerData.then(function (response) {
		let d = null

		if (that.currentOfferReport === 'offer') 
	      d = response.ov
	    else if (that.currentOfferReport === 'cashin')
	      d = response.ci
	    else if (that.currentOfferReport === 'on')
	      d = response.on
        //console.log(d)

        that.morOpt.xAxis.data = that.months
		for (var team in d) {
		  that.morOpt.legend.data.push(team)
		  let dr = {
            name: team,
            type: 'bar',
            stack: 'ov',
            data: d[team]
      }
		  that.morOpt.series.push(dr)
		}
		console.log(that.morOpt)
      }).catch(function (error) {
		console.log(error)
      })
    },
    loadData: function() {
      this.loadMOR(this.currentOfferReport)
    }
  },
  created: function() {
    this.currentYear = moment().year()
    this.offerData = this.loadOfferData()
  },
  mounted: function() {
    this.loadData()
  }
}
</script>